const PEM_MARK = '-----BEGIN';

function toBase64(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary);
}

function derToPem(bytes: Uint8Array): string {
  const lines = toBase64(bytes).match(/.{1,64}/g) ?? [];
  return ['-----BEGIN CERTIFICATE-----', ...lines, '-----END CERTIFICATE-----'].join('\n');
}

/** Контейнер сертификата: его с паролем разбирает сервер. */
export interface CertificateContainer {
  name: string;
  base64: string;
}

export function isCertificateContainer(file: File): boolean {
  return /\.(p12|pfx)$/i.test(file.name);
}

export async function readCertificateContainer(file: File): Promise<CertificateContainer> {
  return { name: file.name, base64: toBase64(new Uint8Array(await file.arrayBuffer())) };
}

/**
 * Файл сертификата или закрытого ключа как текст PEM. Банки присылают их отдельными файлами, а
 * сертификат бывает и двоичным (.cer в формате DER).
 */
export async function readCertificateFile(file: File): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  const text = new TextDecoder().decode(bytes);
  if (text.includes(PEM_MARK)) return text.replace(/\r\n/g, '\n').trim();
  if (/\.(cer|crt|der)$/i.test(file.name) && bytes[0] === 0x30) return derToPem(bytes);
  throw new Error(`${file.name}: это не сертификат и не закрытый ключ в формате PEM`);
}
